import { AfterViewInit, ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit, ViewRef } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { AppService } from 'app/app.service';
import { CentriDiCostoStore } from 'app/main/pages/centri-di-costo/state';
import { WelcomeService } from 'app/main/pages/welcome-page/welcome-page.service';
import { CostantiStorage } from 'app/main/utils/costanti';
import { DialogConfermaComponent } from 'app/main/utils/dialog/dialog-conferma/dialog-conferma.component';
import { NotificaService } from 'app/main/utils/service/notifica.service';
import { ThemeService } from 'app/main/utils/service/theme.service';
import { UtentiService } from 'app/main/utils/service/utente.service';
import { SessioneUtenteQuery, SessioneUtenteStore } from 'app/main/utils/state';
import { Utils } from 'app/main/utils/utils';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, filter, finalize, switchMap, takeUntil } from 'rxjs/operators';
import { navigation } from '../../../navigation/navigation';
import { AppSwitchComponent } from './app-switch/app-switch.component';

@Component({
  standalone: true,
  imports: [
    AppSwitchComponent,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatBadgeModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    FlexLayoutModule,
    RouterLink
  ],
  selector: 'toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  providers: [UtentiService, WelcomeService]
})
export class ToolbarComponent implements OnInit, AfterViewInit, OnDestroy {
  horizontalNavbar: boolean;
  rightNavbar: boolean;
  hiddenNavbar: boolean;
  isMobile;
  navigation: any;
  userStatusOptions: any[];
  notifications = [];

  socio: any;
  nomeCompleto = '';
  iniziali = '';
  fotoUrl: string | null = null;

  isWarnClicked = false;
  isUploadingFoto = false;

  @HostBinding('class.on-image') overImage = false;
  @HostBinding('class.is-scrolled') scrolled = false;

  // Private
  private readonly maxSizeFoto = 1024 * 1024 * 10;
  private readonly mimeFoto = ['image/png', 'image/gif', 'image/jpeg', 'image/bmp', 'image/jpg'];
  private socioInCaricamento = false;
  private _unsubscribeAll: Subject<any>;
  private scrollEl: HTMLElement | null = null;
  private readonly onScroll = () => {
    this.scrolled = !!this.scrollEl && this.scrollEl.scrollTop > 8;
  };

  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   * @param {FuseSidebarService} _fuseSidebarService
   */
  utente;
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _fuseSidebarService: FuseSidebarService,
    private utenteService: UtentiService,
    private appService: AppService,
    private utenteStore: SessioneUtenteStore,
    private utenteQuery: SessioneUtenteQuery,
    private cdcStore: CentriDiCostoStore,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private notificaService: NotificaService,
    private cd: ChangeDetectorRef,
    private sessioneUtenteQuery: SessioneUtenteQuery,
    private themeService: ThemeService,
    private welcomeService: WelcomeService,
    private router: Router
  ) {
    this.utente = this.utenteQuery.loggedUser();
    this.aggiornaAnagrafica();
    // Set the defaults
    this.userStatusOptions = [
      {
        title: 'Online',
        icon: 'icon-checkbox-marked-circle',
        color: '#4CAF50'
      },
      {
        title: 'Away',
        icon: 'icon-clock',
        color: '#FFC107'
      },
      {
        title: 'Do not Disturb',
        icon: 'icon-minus-circle',
        color: '#F44336'
      },
      {
        title: 'Invisible',
        icon: 'icon-checkbox-blank-circle-outline',
        color: '#BDBDBD'
      },
      {
        title: 'Offline',
        icon: 'icon-checkbox-blank-circle-outline',
        color: '#616161'
      }
    ];

    this.navigation = navigation;
    this.isMobile = this.appService.getState('isMobile');
    // Set the private defaults
    this._unsubscribeAll = new Subject();
    this.appService.onReloadSwitch.pipe(takeUntil(this._unsubscribeAll)).subscribe(reload => {
      if (reload) {
        this.utente = this.utenteQuery.loggedUser();
        this.aggiornaAnagrafica();
      }
    });
  }

  ngOnInit(): void {
    this._fuseConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(settings => {
      this.horizontalNavbar = settings.layout.navbar.position === 'top';
      this.rightNavbar = settings.layout.navbar.position === 'right';
      this.hiddenNavbar = settings.layout.navbar.hidden === true;
    });

    this.notificaService.checkNotifiche.pipe(takeUntil(this._unsubscribeAll)).subscribe(should => {
      if (should) {
        this.getListaNotifiche();
      }
    });
    this.sessioneUtenteQuery.isLoggedIn$
      .pipe(distinctUntilChanged(), takeUntil(this._unsubscribeAll))
      .subscribe(loggato => {
        if (loggato) {
          this.utente = this.utenteQuery.loggedUser();
          this.getListaNotifiche();
          if (!this.socio) {
            this.caricaSocio();
          }
        } else {
          this.socio = null;
        }
        this.aggiornaAnagrafica();
      });

    this.sessioneUtenteQuery.loggedInUser$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ utente }) => (this.fotoUrl = utente?.url_img_profilo || null));

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe(() => {
        this.aggiornaOverlay();
        if (!this.socio && this.sessioneUtenteQuery.isLoggedIn()) {
          this.caricaSocio();
        }
      });

    this.aggiornaOverlay();
  }

  ngAfterViewInit(): void {
    this.scrollEl = document.getElementById('container-3');
    this.scrollEl?.addEventListener('scroll', this.onScroll, { passive: true });
  }

  ngOnDestroy(): void {
    this.scrollEl?.removeEventListener('scroll', this.onScroll);
    document.body.classList.remove('toolbar-overlay');
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  private aggiornaOverlay(): void {
    this.overImage = /^\/(academy\/(?!corsi\/dettaglio-video)|ricerca-corsi)/.test(this.router.url);
    document.body.classList.toggle('toolbar-overlay', this.overImage);
    this.onScroll();
  }

  /**
   * Whether the dark theme is currently active. Drives the toolbar icon.
   */
  isDark(): boolean {
    return this.themeService.isDark();
  }

  /**
   * Switch between the light and dark theme. The choice is stored in a cookie
   * by ThemeService, so it survives logout and the switch to the other Brain
   * applications.
   */
  toggleTheme(): void {
    this.themeService.toggle();
  }

  /**
   * Toggle sidebar open
   *
   * @param key
   */
  toggleSidebarOpen(key): void {
    if (key === 'quickPanel' && !this._fuseSidebarService.quickPanelHasOpened.value) {
      this._fuseSidebarService.quickPanelHasOpened.next(true);
    }
    setTimeout(() => {
      this._fuseSidebarService.getSidebar(key).toggleOpen();
    });
  }

  getListaNotifiche() {
    if (localStorage.getItem(CostantiStorage.TOKEN)) {
      this.notificaService
        .listaUltimeNotifiche()
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(data => {
          if (data && !data['error']) {
            this.notifications = data['notifiche'].filter(x => !x.is_letta);
            if (!(<ViewRef>this.cd).destroyed) {
              this.cd.detectChanges();
            }
          }
        });
    }
  }

  getInfoBrain() {
    const dialogRef = this.dialog.open(DialogConfermaComponent, {
      width: '640px',
      data: {
        titolo: 'Avviso',
        isHTML: true,
        showButtonNo: false,
        buttonOkText: 'Ok',
        messaggio: `BRAIN è un applicativo in cloud i cui servizi, ad esclusione della parte relativa ai corsi, sono riservati ai soli associati ANDI in regola con il pagamento della quota associativa.
        <br><br>
        ATTENZIONE: Qualora tu avessi acquistato il servizio “Fatturazione Elettronica” o "Magazzino c/DM registrazione Codici UDI" e non fossi in regola con il versamento della quota associativa ANDI,
        all’atto del decadimento del tuo stato di socio potrai ancora accedere al tuo profilo personale BRAIN ma ti verrà preclusa la possibilità di accedere
        al suddetto servizio. Potrai comunque poter fruire del servizio “Fatturazione Elettronica” tramite il portale di
        <a target="_blank" href="https://web2.unimaticaspa.it/portunidig/newview/index.html">UNIMATICA</a>,
        accessibile tramite le credenziali che ti sono state precedentemente inviate al momento dell’acquisto via PEC.
        <br><br>
        Se ne assicura la compatibilità con i seguenti browser (purché aggiornati alle rispettive ultime versioni).<br>Browser supportati:<br>
        <ul>
        <li>Chrome</li>
        <li>Opera</li>
        <li>Firefox</li>
        </ul>`
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
      }
    });
  }
  /**
   * Search
   *
   * @param value
   */
  search(value): void {
    // Do your search here...
    console.log(value);
  }

  delayWarn() {
    this.isWarnClicked = true;
    this.snackBar.open(
      'Il portale potrebbe subire alcuni rallentamenti o disservizi a causa della migrazione dei dati dal precedente gestore.',
      null,
      {
        verticalPosition: 'top',
        duration: 5000
      }
    );
  }

  toggleVisibility() {
    this.appService.setState('screenLocked', true);
  }

  switchApp(app) {
    if (this.utente.token) {
      Utils.ClearStorageKey(true);
      localStorage.clear();
      this.appService.clearState();
      this.utenteStore.logout();
      this.cdcStore.reset();
      switch (app) {
        case 'ana':
          window.location.href = environment.urlPreLoginAnagrafica + '/' + this.utente.token;
          break;
        case 'soc':
          window.location.href = environment.urlPreLoginSocial + '/' + this.utente.token;
          break;
        case 'ser':
          window.location.href = environment.urlPreLoginServizi + '/' + this.utente.token;
          break;
      }
    } else {
      this.utenteService
        .switchPreLogin()
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(data => {
          if (!data['error']) {
            Utils.ClearStorageKey(true);
            localStorage.clear();
            this.appService.clearState();
            this.utenteStore.logout();
            this.cdcStore.reset();
            switch (app) {
              case 'ana':
                window.location.href = environment.urlPreLoginAnagrafica + '/' + data['response'];
                break;
              case 'soc':
                window.location.href = environment.urlPreLoginSocial + '/' + data['response'];
                break;
              case 'ser':
                window.location.href = environment.urlPreLoginServizi + '/' + data['response'];
                break;
            }
          } else {
            console.error('1');
          }
        });
    }
  }

  cambiaFoto(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';
    if (!file || this.isUploadingFoto) {
      return;
    }
    if (!this.mimeFoto.includes(file.type)) {
      this.erroreFoto('Seleziona un file immagine PNG, GIF, JPEG o BMP.');
      return;
    }
    if (file.size > this.maxSizeFoto) {
      this.erroreFoto('La dimensione massima del file è 10 MB.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    this.salvaFoto(
      this.utenteService.uploadFotoProfilo(formData),
      'Impossibile salvare l’immagine del profilo. Riprova.'
    );
  }

  eliminaFoto(trigger: MatMenuTrigger): void {
    if (this.isUploadingFoto) {
      return;
    }
    trigger.closeMenu();
    this.dialog
      .open(DialogConfermaComponent, {
        data: { titolo: 'Elimina foto profilo', messaggio: 'Vuoi eliminare la foto profilo?', buttonOkText: 'Elimina' }
      })
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(result => {
        if (result === 1) {
          this.salvaFoto(
            this.utenteService.eliminaFotoProfilo(),
            'Impossibile eliminare la foto profilo. Riprova.',
            true
          );
        }
      });
  }

  apriSelettoreFoto(payload: { event: Event; input: HTMLInputElement }): void {
    payload.event.stopPropagation();
    if (!this.isUploadingFoto) {
      payload.input.click();
    }
  }

  private salvaFoto(richiesta: Observable<unknown>, messaggioErrore: string, rimossa = false): void {
    this.isUploadingFoto = true;
    let salvata = false;
    richiesta
      .pipe(
        switchMap(() => {
          salvata = true;
          return this.utenteService.getUtente();
        }),
        finalize(() => (this.isUploadingFoto = false)),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe({
        next: data => {
          const loggedUser = this.utenteQuery.loggedUser();
          const url = data?.utente?.url_img_profilo;
          if (loggedUser && data?.utente && (rimossa || url)) {
            this.utenteStore.login({ ...loggedUser, url_img_profilo: url || null });
          }
        },
        error: () =>
          this.erroreFoto(
            salvata ? 'Operazione eseguita, aggiornamento non riuscito: ricarica la pagina.' : messaggioErrore
          )
      });
  }

  private erroreFoto(messaggio: string): void {
    this.snackBar.open(messaggio, null, { verticalPosition: 'top', duration: 5000 });
  }

  private caricaSocio(): void {
    if (this.socioInCaricamento) {
      return;
    }

    this.socioInCaricamento = true;

    this.welcomeService
      .getNavigation()
      .pipe(
        takeUntil(this._unsubscribeAll),
        finalize(() => (this.socioInCaricamento = false))
      )
      .subscribe(data => {
        this.socio = data && data['socio'] ? data['socio'] : null;
        this.aggiornaAnagrafica();
      });
  }

  private aggiornaAnagrafica(): void {
    const daSocio = this.socio ? `${this.socio.nome || ''} ${this.socio.cognome || ''}`.trim() : '';
    const daSessione = this.utente && this.utente.nome ? String(this.utente.nome) : '';

    this.nomeCompleto = (daSocio || daSessione).trim();

    const parole = this.nomeCompleto.split(/\s+/).filter(Boolean);
    const prima = parole.length ? parole[0].charAt(0) : '';
    const ultima = parole.length > 1 ? parole[parole.length - 1].charAt(0) : '';

    this.iniziali = (prima + ultima).toUpperCase();
  }
}
